import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { RichText } from '@sitecore-jss/sitecore-jss-nextjs';
import { StyledDivider, StTextContainer } from './MinorDNQ.styles';
import { StNextImage } from '../../components/shared/NextImage.styles';
import { MinorDNQProps } from './MinorDNQ.types';
import { StDTPGridContainer } from '../../components/shared/Container/Container.styles';
import UiSubHeading from '../../components/shared/Typography/UiSubHeading';
import ButtonPrimary from '../../components/shared/Button/PrimaryButton';
import { JSSLink } from '../../components/shared/Links/JSSLink.styles';
import useApplyV2Theme from '../../lib/hooks/useApplyV2Theme';

const MinorDNQ = (props: MinorDNQProps): JSX.Element => {
  const theme = useTheme();
  const { isToapplyV2Theme } = useApplyV2Theme();
  if (!props?.fields) return <></>;
  const { icon, content, link, buttonVariant } = props?.fields;

  const backText = link?.value?.text as string;
  const href = link?.value?.href as string | undefined;

  const onBackToHomeClick = (e: React.MouseEvent) => {
    if (!href) return;
    e.preventDefault();
    window.location.href = href;
  };

  return (
    <StDTPGridContainer>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        rowGap="2rem"
        sx={{
          marginTop: '2rem',
        }}
      >
        <StNextImage
          suppressHydrationWarning
          data-testid="icon"
          field={icon}
          width={97}
          height={87}
        />
        <StyledDivider isToapplyV2Theme={isToapplyV2Theme} />
        <StTextContainer>
          {isToapplyV2Theme ? (
            <UiSubHeading
              align="center"
              data-testid="content"
              styles={{
                color: (theme: any) => theme.palette.themeColor.main,
              }}
            >
              <RichText field={content} />
            </UiSubHeading>
          ) : (
            <Box
              data-testid="content"
              textAlign="center"
              sx={{
                color: (theme: any) => theme.palette.themeColor.main,
                fontSize: '2rem',
                fontStyle: 'normal',
                fontWeight: '600',
                lineHeight: '2.5rem',
              }}
            >
              <RichText field={content} />
            </Box>
          )}
        </StTextContainer>
        {isToapplyV2Theme ? (
          <ButtonPrimary
            data-testid="link"
            className="dnq-btn btn"
            aria-label={backText}
            style={{
              paddingInline: '22px',
              minWidth: 'auto',
              [theme.breakpoints.down('sm')]: { paddingBlock: '6px' },
            }}
            onClick={onBackToHomeClick}
          >
            {backText}
          </ButtonPrimary>
        ) : (
          <JSSLink
            data-testid="link"
            className={'dnq-btn btn'}
            variant={buttonVariant?.value || 'contained'}
            field={link}
            onClick={onBackToHomeClick}
            sx={{
              paddingInline: '22px',
              minWidth: 'auto',
              [theme.breakpoints.down('sm')]: {
                paddingBlock: '6px',
              },
            }}
          />
        )}
      </Box>
    </StDTPGridContainer>
  );
};

export default MinorDNQ;
